import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useAppVM = () => {
    const location = useLocation();

    useEffect(() => {
        const scrollContainer = document.querySelector('.rendered-page');
        if (scrollContainer) {
            scrollContainer.scrollTop = 0;
        }
    }, [location.pathname]);
};
